/**
 * Turnstile CAPTCHA is only required on the production domain.
 * On staging/preview/local environments, it is skipped entirely.
 */
export const PRODUCTION_HOSTNAME = "hostcaptain.co";

export const isCaptchaEnabled = (): boolean => {
  return window.location.hostname === PRODUCTION_HOSTNAME;
};
